export const CONTACT_METHODS = [
  { code: 'WHATSAPP', label: 'listing.contactMethod.whatsapp', icon: 'logo_whatsapp' },
  { code: 'CHAT', label: 'listing.contactMethod.chat', icon: 'message_fill' },
  { code: 'PHONE', label: 'listing.contactMethod.phone', icon: 'phone_fill' },
]

export const LISTING_STATUS_META = {
  AVAILABLE: { label: 'listing.status.available', color: '#1a6b42', bg: '#EAF3DE' },
  RESERVED: { label: 'listing.status.reserved', color: '#BA7517', bg: '#FDF6E3' },
  SOLD: { label: 'listing.status.sold', color: '#5F5E5A', bg: '#F1EFE8' },
  EXPIRED: { label: 'listing.status.expired', color: '#5F5E5A', bg: '#F1EFE8' },
}

export function fmtCfa(n,currency) {
  if (n == null || Number.isNaN(Number(n))) return ''
  return `${Math.round(Number(n)).toLocaleString('fr-FR')} ${currency}`
}